<template>
    <el-dialog title="页面元素" :visible.sync="centerDialogVisible" @close="cancel">
  
    <el-form ref="submitData" :model="submitData" label-width="120px" :rules="rules">
      <el-form-item label="页面编号" prop="code">
        <el-input v-model="submitData.code" />
      </el-form-item>
      <el-form-item label="页面名称" prop="name">
        <el-input v-model="submitData.name" />
      </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" style="margin-right:8px">取消</el-button>
      <el-button type="primary"  @click="onSubmit('submitData')">确认</el-button>
      </span>
    </el-dialog>
</template>
<script>
import { createPage, search } from '@/api/system'
import { validateTwenty, validateTenNumber } from '@/api/validate'
export default {
  props: ['menuId', 'clickType', 'eleId', 'appId'],
  data() {
    return {
      submitData: {
        code: '',
        name: '',
        appId: this.appId,
        parentId: this.menuId,
        menuType: 1,
        id: this.eleId
      },
      centerDialogVisible:true,
      rules: {
        code: [{
          required: true,
          validator: validateTenNumber,
          trigger: 'change'
        }],
        name: [{
          required: true,
          validator: validateTwenty,
          trigger: 'change'
        }]
      }

    }
  },
  mounted() {
    if (this.clickType == 1) {
      this.searchInfo()
    }
    console.log(this.menuId,this.eleId,this.appId)
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.create()
        } else {
          return false
        }
      })
    },
    create() {
      createPage(this.submitData).then(res => {
        if (res && res.code == 0) {
          this.$message.success('操作成功')
          this.$emit('returnResult')
        } 
      })
    },
    cancel() {
      this.$emit('returnResult')
    },
    searchInfo() {
      search({
        id: this.eleId,
        menuType: 1
      }).then(res => {
        if (res && res.code == 0) {
          this.submitData.name = res.data[0].name
          this.submitData.code = res.data[0].code
        }
      })
    }
  }
}
</script>
